import request from '@/utils/request'


// 查询积分兑换记录列表
export function listPointsRedeemRecord(query) {
  return request({
    url: '/points/points/redeem/record/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询积分兑换记录分页
export function pagePointsRedeemRecord(query) {
  return request({
    url: '/points/points/redeem/record/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询积分兑换记录详细
export function getPointsRedeemRecord(data) {
  return request({
    url: '/points/points/redeem/record/detail',
    method: 'get',
    params: data
  })
}

// 新增积分兑换记录
export function addPointsRedeemRecord(data) {
  return request({
    url: '/points/points/redeem/record/add',
    method: 'post',
    data: data
  })
}

// 修改积分兑换记录
export function updatePointsRedeemRecord(data) {
  return request({
    url: '/points/points/redeem/record/edit',
    method: 'post',
    data: data
  })
}

// 删除积分兑换记录
export function delPointsRedeemRecord(data) {
  return request({
    url: '/points/points/redeem/record/delete',
    method: 'post',
    data: data
  })
}
